module.exports = __webpack_public_path__ + "img/AF.01e5d2b2.png";